import { render, staticRenderFns } from "./Journalists.vue?vue&type=template&id=467e3b53&"
import script from "./Journalists.vue?vue&type=script&lang=js&"
export * from "./Journalists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports